import {tableFilterToEsQuery} from 'cl-table/utils/elasticsearchUtils';
import jQuery from 'jquery';
import jQueryAjaxRetry from '../../shared/helpers/jQueryAjaxRetry';
import NotificationService from '../../shared/helpers/NotificationService';
import {store} from 'App/store';
import {store as editorStore} from 'crazyEditor/redux/store';
import {setRefreshingFromEbayPercent, setRefreshingFromEbay} from 'MyAccount/ViewDesigns/redux/modules/listingsPage';
import {getSaveData, getListingData, isDraft} from 'crazyEditor/redux/modules/element/elementSelectors';
import {getPublishCode} from 'crazyEditor/core/publish/publish';
import {setSnackbar, setReviseError} from 'crazyEditor/redux/modules/publishDialog/publishDialog';
import {updateCSSUrl} from 'crazyEditor/redux/modules/template/template';
import _ from 'lodash';
import {browserHistory} from 'react-router';
import {openLazyPanel} from 'crazyEditor/redux/modules/panel/panel';
import {TYPES, EDITOR_PANELS} from 'crazyEditor/core/constants/panelConstants';
import {TEMPLATE_NAMES} from 'MyAccount/Listings/consts';
import {getOriginTemplateId} from 'shared/helpers/TemplateService';
import {adjustLocationInStore} from 'shared/components/redux/connectWithRouter';
import {activityLogApi} from 'cl-api';
export const promisesThatNeedToFinishBeforeStartingRevise = [];
const STATUS_OK = 'success';

class EbayService {
  static instance = null;

  constructor() {
    this._requestsHandlers = [];
    NotificationService.subscribe('refresh', notification => {
      const key = notification.message.sellerId || notification.message.requestId;
      if (notification.message && key && this._requestsHandlers[key]) {
        this._requestsHandlers[key](notification.message.done, notification.message);
        if (notification.message.done) {
          delete this._requestsHandlers[key];
        }
      }
    });
  }

  reviseListing(item = this._revisedItem, removeStyles = false) {
    const template = {...getSaveData(editorStore.getState()), originTemplateId: getOriginTemplateId()};
    const {itemID, viewItemURL, draft} = item;
    const openErrorDialog = message => {
      editorStore.dispatch(setReviseError(message));
      editorStore.dispatch(setSnackbar({snackbarOpen: false}));
    };
    this._revisedItem = item;
    editorStore.dispatch(
      setSnackbar({
        snackbarMessage: draft ? 'Saving your draft...' : 'Revising your listing...',
        snackbarActionLabel: null,
        snackbarOpen: true,
        snackbarAutoHide: false,
        snackbarAction: null,
      })
    );
    editorStore.dispatch(setReviseError(null));
    if (!draft) {
      window.analytics.track('Revise Listing Clicked', {
        'Listing ID': itemID,
        'Listing Link': viewItemURL,
        'Mobile Optimized': template.mobileOptimized === true,
      });
    }
    const reviseListingPromise = jQuery.Deferred();
    jQuery.when(...promisesThatNeedToFinishBeforeStartingRevise).done(result => {
      const {publishCode, templateCSS} = getPublishCode(removeStyles);
      jQueryAjaxRetry({
        method: 'POST',
        url: '/ebay/new-user/revise-listing',
        data: {
          itemId: itemID,
          description: publishCode,
          templateCSS,
          template,
          listingData: _.pick(editorStore.getState().listingData, ['title', 'description']),
          draft: !!draft,
        },
      }).then(
        result => {
          if (result.status === STATUS_OK) {
            const {pathname, query} = adjustLocationInStore(editorStore.getState()).routing.location;
            browserHistory.replace({pathname, query: _.omit(query, 'id')});
            editorStore.dispatch(
              setSnackbar(
                draft
                  ? {
                      snackbarMessage: 'Draft saved successfully',
                      snackbarActionLabel: null,
                      snackbarOpen: true,
                      snackbarAutoHide: true,
                      snackbarAction: null,
                    }
                  : {
                      snackbarMessage: 'Listing revised successfully',
                      snackbarActionLabel: 'see it on ebay',
                      snackbarOpen: true,
                      snackbarAutoHide: true,
                      snackbarAction: () => {
                        window.open(this._revisedItem.viewItemURL);
                      },
                    }
              )
            );
            const listingData = getListingData(editorStore.getState());
            if (
              !isDraft(editorStore.getState()) &&
              (!listingData.templateName || listingData.templateName === TEMPLATE_NAMES.NO_TEMPLATE)
            ) {
              editorStore.dispatch(openLazyPanel(EDITOR_PANELS.SAVE_AS_TEMPLATE, TYPES.EDITOR_PANEL));
            }
            if (result.cssUrl) {
              editorStore.dispatch(updateCSSUrl(result.cssUrl));
            }
            reviseListingPromise.resolve(result);
          } else {
            reviseListingPromise.reject(result.message);
            openErrorDialog(result.message || `Unknown error while ${draft ? 'saving' : 'revising'} listing`);
          }
        },
        () => {
          openErrorDialog(`Unknown error while ${draft ? 'saving' : 'revising'} listing`);
        }
      );
    });
    return reviseListingPromise;
  }

  abort = requestId => {
    delete this._requestsHandlers[requestId];
  };

  refreshSellerItems(options, callback = () => {}) {
    const {sellerId, abort} = options;
    if (abort) {
      store.dispatch(setRefreshingFromEbay(false, sellerId, true));
      this._requestsHandlers[sellerId] = null;
      return activityLogApi.abortActivities(tableFilterToEsQuery({SourceName: sellerId}));
    }

    store.dispatch(setRefreshingFromEbay(true, sellerId, false));
    this._requestsHandlers[sellerId] = (isComplete, message) => {
      if (isComplete) {
        this._requestsHandlers[sellerId] = null;
        store.dispatch(setRefreshingFromEbay(false, sellerId, false));
      } else {
        let percent;
        if (message.chunksReady < message.chunkCount) {
          percent = Math.ceil((10 * message.chunksReady) / message.chunkCount);
        } else {
          percent = Math.max(Math.round(100 - (100 * message.totalPagesRemain) / message.totalNumberOfPages), 10);
        }
        store.dispatch(setRefreshingFromEbayPercent(percent, sellerId));
      }
      callback(message);
    };
    const promise = jQuery.ajax({
      method: 'GET',
      url: '/ebay/new-user/refresh-items',
      data: {
        ...options,
      },
    });
    promise.fail(console.error.bind(console, 'refreshSellerItems'));
    return promise;
  }
}

EbayService.instance = new EbayService();

export default EbayService.instance;
